import { Action, AsyncAction } from "../../../types/actions";
import {
  PasscodeList,
} from "../../../types/working-model";
import { GetPasscodeLists } from "../../../connection/passcode-lists";

export const GET_PASSCODE_LISTS = "GET_PASSCODE_LISTS";
export function getPasscodeLists(channel: number, token: string): AsyncAction {
  return {
    type: GET_PASSCODE_LISTS,
    promise: GetPasscodeLists(channel, token)
  };
}

export const ADD_PASSCODE_LIST = "ADD_PASSCODE_LIST";
export function addPasscodeList(list: PasscodeList): Action {
  return {
    type: ADD_PASSCODE_LIST,
    payload: list
  };
}
